import { render, staticRenderFns } from "./car-update-serial.vue?vue&type=template&id=4dc67f24&"
import script from "./car-update-serial.vue?vue&type=script&lang=js&"
export * from "./car-update-serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports